export default "__VITE_ASSET__LreYWh2P__"